(() => {
  if (customElements.get('hemset-guide')) return;

  class HemsetGuide extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    initialize() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.cards = Array.from(this.querySelectorAll('[data-family-card]'));
      this.buttons = Array.from(this.querySelectorAll('[data-family-filter]'));
      this.filters = this.querySelector('[data-family-filters]');
      this.status = this.querySelector('[data-family-status]');
      if (!this.cards.length || !this.filters || !this.buttons.length) return;

      this.addEventListener('click', (event) => {
        const button = event.target.closest?.('[data-family-filter]');
        if (!button || button.closest('hemset-guide') !== this) return;
        this.setFilter(button.dataset.familyFilter);
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest?.('[data-family-card]');
        if (card && this.cards.includes(card)) this.setFilter('all');
      }, { signal });

      window.addEventListener('hashchange', () => this.revealHashTarget(), { signal });
      this.setFilter('all');
      this.filters.hidden = false;
      this.revealHashTarget();
    }

    setFilter(category) {
      const validCategory = ['all', 'tees', 'longsleeves'].includes(category) ? category : 'all';
      let visibleCount = 0;
      this.cards.forEach((card) => {
        const visible = validCategory === 'all' || card.dataset.familyCategory === validCategory;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.familyFilter === validCategory));
      });
      if (this.status) {
        const template = this.status.dataset.statusTemplate || '';
        this.status.textContent = template.replaceAll('[count]', String(visibleCount)).replaceAll('[total]', String(this.cards.length));
      }
    }

    revealHashTarget() {
      let targetId;
      try {
        targetId = decodeURIComponent(window.location.hash.slice(1));
      } catch {
        return;
      }
      const card = this.cards.find((item) => item.id === targetId);
      if (card?.hidden) {
        this.setFilter('all');
        card.scrollIntoView({ block: 'start' });
      }
    }
  }

  customElements.define('hemset-guide', HemsetGuide);
})();

